import React from 'react';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';

export class RectangularInputForm extends React.Component {
  static convertAllValueToFloat(object) {
    return Object.keys(object)
      .reduce((convertedObj, key) => ({ ...convertedObj, [key]: parseFloat(object[key] || '0')}), {});
  }

  constructor(props) {
    super(props);
    this.formRef = null;
  }

  renderOriginInputs() {
    const {
      origin: { x, y, z },
      t,
    } = this.props;

    return [
      <FieldGroup
        id="rec-x"
        key="rec-x"
        field="x"
        type="number"
        label={`X (${t('meter abbrv')})`}
        placeholder="5"
        value={x}
        defaultDirty={true}
      />,
      <FieldGroup
        id="rec-y"
        key="rec-y"
        field="y"
        type="number"
        label={`Y (${t('meter abbrv')})`}
        placeholder="6"
        value={y}
        defaultDirty={true}
      />,
      <FieldGroup
        id="rec-z"
        key="rec-z"
        field="z"
        type="number"
        label={`Z (${t('meter abbrv')})`}
        placeholder="9"
        value={z}
        defaultDirty={true}
      />,
    ];
  }

  renderSizeInputs() {
    const {
      size: { width, height },
      t,
    } = this.props;

    return [
      <FieldGroup
        id="rec-width"
        key="rec-width"
        field="width"
        type="number"
        label={`${t('width')} (${t('meter abbrv')})`}
        placeholder="100"
        value={width}
        min={0.01}
        defaultDirty={true}
      />,
      <FieldGroup
        id="rec-height"
        key="rec-height"
        field="height"
        type="number"
        label={`${t('height')} (${t('meter abbrv')})`}
        placeholder="100"
        value={height}
        min={0.01}
        defaultDirty={true}
      />,
    ];
  }

  renderAngleInputs() {
    const { angle, t } = this.props;

    return (
      <FieldGroup
        id="rec-angle"
        key="rec-angle"
        field="angle"
        type="number"
        label={`${t('angle')} (°)`}
        placeholder="20"
        value={angle}
        defaultDirty={true}
        min={0}
        max={90}
      />
    );
  }

  render() {
    const { name, origin, size, angle, ...otherAttr } = this.props;

    return (
      <Form
        {...otherAttr}
        showThumbnail={false}
        ref={ref => (this.formRef = ref)}
        onDirty={() => {this.formRef && this.props.onDataChanged(
              name,
              RectangularInputForm.convertAllValueToFloat(this.formRef.getFormData())
            )}
        }
      >
        {origin !== undefined && this.renderOriginInputs()}
        {size !== undefined && this.renderSizeInputs()}
        {angle !== undefined && this.renderAngleInputs()}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sc_editor/RectangularInputForm.js